import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import PageHeading from '../components/PageHeading';
import { IconLock } from '../components/Icons';
import ClientReporting from '../components/vectorDashboard/ClientReporting';
import { hasClientReportingAccess, isClientReportingElevated } from '../utils/tierAccess';
import './VectorDashboardPage.css';

export default function VectorDashboardPage({
  user,
  isAdmin,
  isVectorAdmin = false,
  isMax = false,
  isPro = false,
  isBeta = false,
  tierReady,
  authLoading,
  onUpgrade,
  onNavigate,
}) {
  const { isFullAdmin, adminViewAs } = useAuth();
  const showClientReportingAdmin = Boolean(isFullAdmin && adminViewAs === 'admin');
  const hasAccess = hasClientReportingAccess({
    isSignedIn: Boolean(user),
    isPro,
    isMax,
    isBeta,
    isAdmin,
    isVectorAdmin,
  });
  const isElevated = isClientReportingElevated({ isAdmin, isVectorAdmin, isMax });

  if (!tierReady || authLoading) {
    return <p className="vd-muted">Loading…</p>;
  }

  if (!user) {
    return (
      <div className="vd-locked">
        <PageHeading
          title="My Portfolio"
          description="Sign in to link brokerages and view performance for your connected accounts."
        />
        <div className="upgrade-required-page">
          <div className="upgrade-required-content">
            <div className="pro-lock-icon">
              <IconLock size={48} />
            </div>
            <h2 className="pro-lock-title">My Portfolio</h2>
            <p className="pro-lock-subtitle">Sign in to continue</p>
            <button
              type="button"
              className="pro-lock-upgrade-button"
              onClick={() => onNavigate && onNavigate('login')}
            >
              Sign in
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="vd-page">
      <ClientReporting
        isElevated={isElevated}
        showClientReportingAdmin={showClientReportingAdmin}
        userId={user?.id}
        userEmail={user?.email}
        requiresProUpgrade={!hasAccess}
        onUpgrade={onUpgrade}
        pageDescription="Link brokerages and view performance for your connected accounts."
      />
    </div>
  );
}
